import React from 'react';
import './input-custom.css';
import { TourStoryType } from '../../../types/tourStory';

interface ActionsColumnProps {
  record: TourStoryType;
  handleChangeInputVideo: Function;
  handleAddVideo: Function;
  loading?: boolean;
}

export const InputVideo = (props: ActionsColumnProps) => {
  const { record, handleChangeInputVideo, handleAddVideo, loading } = props;
  const url = record?.url || '';
  const isBlock = record?.type === 'VIDEO';

  return (
    <div className="add-video-container">
      <input
        type="text"
        placeholder="Video URL"
        value={url}
        onChange={event => {
          handleChangeInputVideo(record.index, event.target.value);
        }}
        disabled={isBlock}
        className="video-url-input"
        draggable
        onDragStart={event => event.preventDefault()}
      />
      {url && !isBlock && (
        <button
          type="button"
          disabled={loading}
          onClick={() => handleAddVideo(record.index)}
          className="add-video-button"
        >
          ADD VIDEO
        </button>
      )}
    </div>
  );
};
